var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4455 12.418L1.61333 12.418C0.721587 12.418 0 11.7193 0 10.8559L0 3.91509C0 3.05169 0.721587 2.35303 1.61333 2.35303L13.4455 2.35303C14.3372 2.35303 15.0588 3.05169 15.0588 3.91509V10.859C15.0588 11.7193 14.3372 12.418 13.4455 12.418Z",
    fill: "url(#paint0_linear_14_4179)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5861 11.9615C14.2931 12.2453 13.8898 12.4192 13.4455 12.4192L1.61333 12.4192C1.16903 12.4192 0.765702 12.2453 0.472656 11.9615L6.38715 6.23498C7.01735 5.6248 8.03829 5.6248 8.6685 6.23498L14.5861 11.9615Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5864 2.81066L8.66874 8.53723C8.03853 9.14741 7.0176 9.14741 6.38739 8.53723L0.4729 2.81066C0.765947 2.52693 1.16928 2.35303 1.61357 2.35303L13.4457 2.35303C13.89 2.35303 14.2933 2.52693 14.5864 2.81066Z",
    fill: "#FFD53C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3573 13.3333L2.30949 13.3333C1.40149 13.3333 0.666748 12.6391 0.666748 11.7813L0.666748 4.88524C0.666748 4.0274 1.40149 3.33325 2.30949 3.33325L14.3573 3.33325C15.2653 3.33325 16.0001 4.0274 16.0001 4.88524V11.7843C16.0001 12.6391 15.2653 13.3333 14.3573 13.3333Z",
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_4179",
    x1: 7.5294,
    y1: 2.35303,
    x2: 7.5294,
    y2: 12.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD730"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.00121c4b6ef805ae331c8fe053ad8b93.svg";
export { ForwardRef as ReactComponent };